import { Component } from "@angular/core";

@Component({
  selector: "app-low-kdf",
  templateUrl: "low-kdf.component.html",
})
export class LowKdfComponent {}
